export default __webpack_public_path__ + "static/media/help.2379d2ec.svg";